import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { ASSETS } from "@/lib/assets";
import { SEO } from "@/components/SEO";
import { ClearbookContactEmbed } from "@/components/ClearbookContactEmbed";
import { CLEARBOOK_BOOKING_URL } from "@/lib/clearbook";

export const Kontakt = () => {
  return (
    <>
      <SEO
        title="Kontakt Farum Kloak – Døgnvagt 44 48 06 16"
        description="Kontakt Farum Kloak. Ring til vores døgnvagt på 44 48 06 16 eller send en besked. Vi svarer hurtigt på både akutte opgaver og faste samarbejder."
      />
      <PageHero
        eyebrow="Kontakt"
        title={<>Skal vi tage <em className="text-[color:var(--fk-gold)]">dialogen?</em></>}
        subtitle="Uanset om det handler om en akut opgave, et fast samarbejde eller en konkret forespørgsel, svarer vi hurtigt og siger tingene, som de er."
        image={ASSETS.images.teamGroup}
      />

      <section
        data-testid="kontakt-section"
        className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28"
      >
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16">
          {/* Direct info */}
          <div className="md:col-span-5 space-y-10">
            <div className="eyebrow mb-4">Direkte linjer</div>

            <div className="flex items-start gap-5">
              <Phone className="w-5 h-5 mt-1 text-[color:var(--fk-gold)]" />
              <div>
                <div className="text-xs tracking-[0.18em] uppercase text-white/50 mb-1">Døgnvagt</div>
                <a
                  data-testid="kontakt-phone"
                  href={ASSETS.brand.phoneTel}
                  className="font-display text-3xl hover:text-[color:var(--fk-gold)] transition-colors"
                >
                  {ASSETS.brand.phone}
                </a>
              </div>
            </div>

            <div className="flex items-start gap-5">
              <Mail className="w-5 h-5 mt-1 text-[color:var(--fk-gold)]" />
              <div>
                <div className="text-xs tracking-[0.18em] uppercase text-white/50 mb-1">Email</div>
                <a
                  data-testid="kontakt-email"
                  href={`mailto:${ASSETS.brand.email}`}
                  className="font-display text-2xl hover:text-[color:var(--fk-gold)] transition-colors"
                >
                  {ASSETS.brand.email}
                </a>
              </div>
            </div>

            <div className="flex items-start gap-5">
              <MapPin className="w-5 h-5 mt-1 text-[color:var(--fk-gold)]" />
              <div>
                <div className="text-xs tracking-[0.18em] uppercase text-white/50 mb-1">Område</div>
                <div className="font-display text-2xl">Nordsjælland &amp; Storkøbenhavn</div>
              </div>
            </div>

            <div className="flex items-start gap-5">
              <Clock className="w-5 h-5 mt-1 text-[color:var(--fk-gold)]" />
              <div>
                <div className="text-xs tracking-[0.18em] uppercase text-white/50 mb-1">Åbningstid</div>
                <div className="font-display text-2xl">24/7 · døgnvagt</div>
              </div>
            </div>

            <a
              href={CLEARBOOK_BOOKING_URL}
              data-testid="kontakt-booking"
              className="inline-block mt-6 px-7 py-4 text-[11px] tracking-[0.24em] uppercase border border-[color:var(--fk-gold)] text-[color:var(--fk-gold)] hover:bg-[color:var(--fk-gold)] hover:text-black transition-all duration-300"
            >
              Book opgave online
            </a>
          </div>

          {/* Clearbook contact embed */}
          <div className="md:col-span-7">
            <div className="border border-white/10 p-8 md:p-12 bg-[color:var(--fk-bg-2)]">
              <div className="eyebrow mb-6">Send en besked</div>
              <h2 className="font-display text-3xl md:text-4xl leading-tight mb-10">
                Fortæl os om <em className="text-[color:var(--fk-gold)]">opgaven.</em>
              </h2>

              <ClearbookContactEmbed />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
